import { useState, useEffect } from "react";
import { InputAdornment, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { Code4ReportAction } from "../../../../store/Code4Report/Code4Report-slice";

const AlternativeNoteCell = ({ row, isRequired, disabled = false }) => {
	const dispatch = useDispatch();
	const [inputValue, setInputValue] = useState(row.alternative_note || "");

	useEffect(() => {
		const handler = setTimeout(() => {
			const updatedRow = { ...row, alternative_note: inputValue };
			// console.log(updatedRow);
			dispatch(Code4ReportAction.updateEditedTable(updatedRow));
		}, 50); // debounce delay

		return () => clearTimeout(handler);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputValue, dispatch]);

	return (
		<TextField
			variant="standard"
			disabled={disabled}
			InputProps={{
				startAdornment: isRequired ? (
					<InputAdornment position="start">
						<span style={{ color: "red", fontWeight: 700 }}>*</span>
					</InputAdornment>
				) : (
					<span style={{ paddingRight: 15 }}></span>
				),
			}}
			size="small"
			value={inputValue}
			onChange={(e) => setInputValue(e.target.value)}
			onKeyDown={(e) => {
				e.stopPropagation();
			}}
		/>
	);
};

export default AlternativeNoteCell;
